export const getSuppliedBalance = async (artContract, address) => {
  return await artContract.balanceOfUnderlyingPrior(address);
};

export const getSupplyApy = async (artContract) => {
  return await artContract.getSupplyAPY();
};

export const getBorrowApy = async (alrContract, ahrContract) => {
  const borrowApyAlr = await alrContract.getBorrowAPY();
  const borrowApyAhr = await ahrContract.getBorrowAPY();
  const borrowApy = borrowApyAlr.add(borrowApyAhr).div(2);
  return borrowApy;
};

export const getBorrowBalance = async (alrContract, ahrContract, address) => {
  const borrowBalanceAlr = await alrContract.borrowBalancePrior(address);
  const borrowBalanceAhr = await ahrContract.borrowBalancePrior(address);
  const borrowBalance = borrowBalanceAlr.add(borrowBalanceAhr);
  return borrowBalance;
};

export const getLiquidity = async (alrContract, ahrContract) => {
  const liquidityAlr = await alrContract.getCash();
  const liquidityAhr = await ahrContract.getCash();

  if (liquidityAlr.lt(liquidityAhr)) {
    const liquidity = liquidityAlr.add(liquidityAlr);
    return liquidity;
  } else {
    const liquidity = liquidityAhr.add(liquidityAhr);
    return liquidity;
  }
};
